import * as constants from '../constants';

const tools = require('helpers/tools');

/** ACTION-CREATORS * */

export const actions = {
    getLocationAgencies: (locationId) => ({
        type: constants.GET_LOCATION_AGENCIES,
        locationId,
    }),
    addLocationAgency: (locationId, prefill = {}) => {
        const locationAgency = Object.assign({}, emptyLocationAgency, {
            ...prefill,
            locationId,
        });
        return {
            type: constants.ADD_LOCATION_AGENCY,
            locationAgency,
        };
    },
    editLocationAgency: (locationAgency) => ({
        type: constants.EDIT_LOCATION_AGENCY,
        locationAgency,
    }),
    saveLocationAgency: (locationAgency) => ({
        type: constants.SAVE_LOCATION_AGENCY,
        locationAgency,
    }),
    deleteLocationAgency: (locationAgency) => ({
        type: constants.DELETE_LOCATION_AGENCY,
        locationAgency,
    }),
};

const emptyLocationAgency = {
    locationId: '',
    employeeId: '',
    agencyId: '',
    fullAmount: '',
    shareLocation: '',
    note: '',
    billedAt: ''
};

/** STATE & MUTATIONS * */
export default function locationAgencyReducer(
    state = {
        locationAgencies: [],
        editItem: null,
        loading: false,
        loadError: false,
        saving: false,
        saveSuccess: false,
        saveError: false,
        deleting: false,
        deleteError: false,
        deleteSuccess: false,
    },
    action
) {
    switch (action.type) {
        case constants.GET_LOCATION_AGENCIES:
            return tools.update(state, {
                locationAgencies: [],
                loading: true,
                loadError: false,
                saveSuccess: false,
                saveError: false,
            });

        case constants.GET_LOCATION_AGENCIES_ERROR:
            return tools.update(state, {
                locationAgencies: [],
                loading: false,
                loadError: action.err,
            });

        case constants.GET_LOCATION_AGENCIES_SUCCESS:
            return tools.update(state, {
                locationAgencies: action.data,
                loading: false,
                loadError: false,
            });

        case constants.ADD_LOCATION_AGENCY:
        case constants.EDIT_LOCATION_AGENCY:
            return tools.update(state, {
                editItem: action.locationAgency,
            });

        case constants.EDIT_LOCATION_AGENCY_CANCEL:
            return tools.update(state, {
                editItem: null,
                saveSuccess: false,
                saveError: false,
                saving: false,
            });

        case constants.SAVE_LOCATION_AGENCY:
            return tools.update(state, {
                saving: true,
                saveError: false,
                saveSuccess: false,
            });

        case constants.POST_LOCATION_AGENCY_ERROR:
        case constants.PUT_LOCATION_AGENCY_ERROR:
            return tools.update(state, {
                saving: false,
                saveError: action.err,
                saveSuccess: false,
            });

        case constants.POST_LOCATION_AGENCY_SUCCESS:
            return tools.update(state, {
                saving: false,
                saveError: false,
                saveSuccess: true,
                locationAgencies: [...state.locationAgencies, action.data.locationAgency],
            });

        case constants.PUT_LOCATION_AGENCY_SUCCESS:
            return {
                ...state,
                saving: false,
                saveError: false,
                saveSuccess: true,
                locationAgencies: state.locationAgencies.map((locationAgency) =>
                    locationAgency.id === action.data.locationAgency.id ? action.data.locationAgency : locationAgency
                ),
            };

        case constants.DELETE_LOCATION_AGENCY_SUCCESS:
            // Remove deleted item from store
            return tools.update(state, {
                locationAgencies: tools.removeItemByProp(state.locationAgencies, 'id', action.data.id),
                deleteError: false,
                deleteSuccess: true,
            });

        default:
            return state;
    }
}
